<script>
export let params = {};
import Fa from 'svelte-fa'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
let information = params.information||'';

import feathers from '../web_feathers.js';
const new_password = feathers.service('new_password');
let message;
let error;
let loading=false;
import Spinner from 'svelte-spinner';

async function request(){
	loading=true;
	message=error=null;
	return new_password.create({information})
		.then(()=> message = 'We sent a link to your email address. Please click on the link to create your account.')
		.catch(e=>error=e)
		.finally(()=>loading=false);
	}

</script>



<main>

<form>

<div class="container">
	<div class="row justify-content-md-center">
		<div class="col-lg-6 col-md-8 col-s-12">
			<h2 class="ff-dunbar">Create Password</h2>
			</div>
			</div>
		<div class="row mt-3 justify-content-md-center">
		<div class="col-lg-6 col-md-8 col-s-12">
			<label for="account" class="ff-dunbar title-2">Phone #, Email, or SIM #</label><br>
			<input class="form-control" type="email" name="email" id="account" autocomplete="email" placeholder="Phone #, Email, or SIM #" bind:value={information}><br>
			<i>We will send a link to the email on file.</i>
		</div></div>

		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
		<button disabled={loading} type="submit" class="btn btn-primary form-control" on:click|preventDefault={request}>
			{#if loading} <Spinner /> {/if}
			Continue <Fa icon={faChevronRight}/>
			</button>
		</div></div>
	
		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
		{#if message}
			<div class="alert alert-success">{message}</div>
		{:else if error}
			<div class="alert alert-danger">{error}</div>
		{/if}
			</div></div>

	</div>

	</form>

</main>
	